module.exports = __webpack_public_path__ + "static/media/signature.314cf371.png";